import { useMutation } from 'react-query';
import type { AxiosResponse } from 'axios';
import { axiosInstance } from '@shared/lib/axios';
import type { TAxiosError } from '@shared';
export type TUseResetPasswordPayload = {
  newPassword: string;
  resetToken: string;
};
export const useResetPassword = () => useMutation<unknown, TAxiosError, TUseResetPasswordPayload>(payload => axiosInstance.post<unknown, AxiosResponse<unknown>, TUseResetPasswordPayload>('/user/reset', payload));